import React from "react";
import {
    Avatar,
    Box,
    Paper,
    Stack,
    Typography,
    Divider,
} from "@mui/material";
// import ArticleIcon from "@mui/icons-material/Article";
import { MdArticle } from "react-icons/md";

const Articles = ({ articles = [] }) => {
    return (
        <Box px={{ xs: 2, sm: 4 }} py={2}>
            <Typography variant="h5" gutterBottom>
                Articles
            </Typography>

            <Stack spacing={2}>
                {articles.map((notif) => (
                    <Paper
                        key={notif.id}
                        elevation={2}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            p: 2,
                            gap: 2,
                            borderRadius: 3,
                            backgroundColor: "#fdfdfd",
                            "&:hover": {
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                    >
                        <Avatar
                            variant="rounded"
                            src={notif?.featuredImagePath || ""}
                            sx={{ width: 64, height: 64, bgcolor: "#81c784" }}
                        >
                            {!notif?.featuredImagePath && <MdArticle />}
                        </Avatar>

                        <Box flexGrow={1}>
                            <Typography variant="h6" color="text.primary" gutterBottom>
                                {notif.title}
                            </Typography>

                            {notif.shortDescription && (
                                <Typography variant="body2" color="text.secondary">
                                    {notif.shortDescription}
                                </Typography>
                            )}

                            <Divider sx={{ my: 1 }} />

                            <Typography variant="caption" color="text.secondary">
                                {new Date(notif.publishedDate).toDateString()}
                            </Typography>
                        </Box>
                    </Paper>
                ))}
            </Stack>
        </Box>
    );
};

export default Articles;
